const requestWithImage = url => {
  const image = new Image();
  image.alt = '';
  image.src = url;
};
export default requestWithImage;